// extracted by mini-css-extract-plugin
module.exports = {"card":"PixInfinityTable_card__3iBLa","table":"PixInfinityTable_table__2cX3i"};